"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  toggle: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 8,
    cursor: 'pointer'
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/Select/styles.js
// module id = ./node_modules/quark-web/components/form/Select/styles.js
// module chunks = 0